export default __webpack_public_path__ + "974471c24e119625c868af531d8d0cc8.png";